import React, { Component, useState, useEffect } from "react";
import { HubConnection } from "@aspnet/signalr";
import { GetChatAll } from "./API";
import FromItem from "./FromItem";
import ToItem from "./ToItem";
import { GetStudentName } from "../../GeneralAPI";
import { withLocalize } from "react-localize-redux";
import RecentChats from "./RecentChats";

class Chat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      message: "",
      messages: [],
      nick: "",
      regnum: this.props.match.params.regnum,
      hubConnection: null
    };
    this.fetch();
  }
  sendMessage = e => {
    this.state.hubConnection
      .invoke(
        "SendToStudent",
        this.state.nick,
        this.state.regnum,
        this.state.message
      )
      .catch(err => console.error(err));

    this.setState({ message: "" });
    e.preventDefault();
  };
  fetch() {
    GetChatAll(this.props.match.params.regnum).then(data => {
       this.setState({ messages: data });
    });
    GetStudentName(this.props.match.params.regnum).then(data => {
      this.setState({ name: data });
    });
  }
  componentDidUpdate(prevprops) {
    if( this.props.match.params.regnum != prevprops.match.params.regnum )
    {
      
      this.fetch()

      this.setState({regnum:this.props.match.params.regnum})

    }
    

  }

  componentDidMount() {
    window.App.init();

    const nick = "";

    const signalR = require("@aspnet/signalr");

    let hubConnection = new signalR.HubConnectionBuilder()
      .withUrl("/chat")
      .build();

    hubConnection.on("send", data => {
      console.log(data);
    });
    hubConnection.start().then(() => hubConnection.invoke("send", "Hello"));

    this.setState({ hubConnection, nick }, () => {
      hubConnection
        .start()
        .then(() => console.log("Connection started!"))
        .catch(err =>
          console.log(
            "Error while establishing connection :(" + JSON.stringify(err)
          )
        );

      hubConnection.on("sendToStudent", (nick, receivedMessage) => {
        const text = `${nick}: ${receivedMessage}`;

        const messages2 = this.state.messages.concat([
          { to: nick, message: receivedMessage }
        ]);
        this.setState({ messages: messages2 });
      });
    });
  }
  render() {
    let langCode = "en";
    if (this.props.activeLanguage !== undefined) {
      langCode = this.props.activeLanguage.code;
    }
    return (
      <div>
        {/* <br />
        <input
          type="text"
          value={this.state.regnum}
          onChange={e => this.setState({ regnum: e.target.value })}
        />

        <input
          type="text"
          value={this.state.message}
          onChange={e => this.setState({ message: e.target.value })}
        />

        <button onClick={this.sendMessage}>Send</button>
        <br /> */}
        <div>
        <div class="card">
          <div class="card-block">
            <h4 class="card-title m-t-0">Messaging</h4>
            <p class="card-text">You can communicate with your classmates.</p>
            </div>
          </div>
          <div class="row">
            <RecentChats langCode={langCode} />
            <div class="col-8 col-xs-12">
              <div class="widget-chat widget-chat-rounded">
                <div class="widget-chat-header">
                  <div class="widget-chat-header-icon">
                  <div class="image">
                    <img src={`api/General/Image/${this.state.regnum}`} alt=""/></div>
                  
                    
                  </div>
                  <div class="widget-chat-header-content">
                    <h4 class="widget-chat-header-title">
                      {langCode == "ar"
                        ? this.state.name.nameArabic
                        : this.state.name.nameEnglish}
                    </h4>
                    <p class="widget-chat-header-desc">55 members, 4 online</p>
                  </div>
                </div>

                <div
                  class="widget-chat-body"
                  data-scrollbar="true"
                  data-height="435px"
                >
                  {/* <div class="text-center text-muted m-10 f-w-600">Today</div> */}
                  {this.state.messages.map((message, index) =>
                    message.to == this.state.regnum ? (
                      <ToItem {...message} />
                    ) : (
                      <FromItem {...message} from={this.state.regnum} />
                    )
                  )}
                </div>

                <div class="widget-input widget-input-rounded">
                  <form action="" method="POST" name="">
                    <div class="widget-input-container">
                      {/* <div class="widget-input-icon"><a href="#" class="text-grey"><i class="fa fa-camera"></i></a></div> */}
                      <div class="widget-input-box">
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          placeholder="Write a message..."
                          value={this.state.message}
                          onChange={e =>
                            this.setState({ message: e.target.value })
                          }
                        />
                      </div>
                      <div class="widget-input-icon">
                        <button onClick={this.sendMessage} class="btn ">
                          <i class="fas fa-paper-plane text-primecolor" />
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withLocalize(Chat);



// WEBPACK FOOTER //
// ./src/pages/Chat/Chat.js